require('./bootstrap');
import Vue from 'vue'
require("./plugins/vue-toastification");
import {createInertiaApp, Link} from '@inertiajs/inertia-vue'
import {InertiaProgress} from '@inertiajs/progress'
import VueSweetalert2 from 'vue-sweetalert2'
import vuetify from './plugins/vuetify'
Vue.component("Link", Link);
Vue.mixin({methods: {route: window.route}});
Vue.mixin(require('./plugins/base'));
import 'sweetalert2/src/sweetalert2.scss'

const instance = axios.create({
    baseURL: `${window.location.origin}/`,
    timeout: 1000 * 15,
    headers: {
        'X-CSRF-TOKEN': document.head.querySelector('meta[name="_token"]').content,
    },
})
window.$axios = instance


createInertiaApp({
    title: title =>(title ? `${title} - MTF VISIONS` : 'MTF MTF VISIONS'),
    resolve: name => import(`@/Pages/${name}`).then(module => module.default),
    setup({el, App, props, plugin}) {
        Vue.use(plugin);
        Vue.use(VueSweetalert2);
        new Vue({
            vuetify,
            render: h => h(App, props),
        }).$mount(el)
    },
});

InertiaProgress.init();
